"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EventBus = new _vue.default();
var _default = exports.default = EventBus;



//////////////////
// WEBPACK FOOTER
// ./~/primevue/toastservice/ToastEventBus.js
// module id = 775
// module chunks = 7